import lodash from 'lodash'
import { BindAll } from 'lodash-decorators'
import { EnumApiStationery } from '../../api'
import { AjaxBasics } from '../../helpers/ajaxBasics'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'
import { Pagination } from '../basics/pagination'

@BindAll()
export class ControllerStationery {
  constructor(protected $ajax: AjaxBasics) {}

  /**
   * 分页列表数据 (已弃用)
   * @memberof ControllerStationery
   * @deprecated
   */
  Pagination = new Pagination(this.$ajax, {
    url: EnumApiStationery.Products,
    key: 'id'
  })

  /**
   * 分页列表数据v2
   * @memberof ControllerStationery
   */
  pagePagination = new PagePagination({
    url: EnumApiStationery.Products
  })
}
export default ControllerStationery
